export const getRiskGroupNameForExamplePage = (risk: string) => {
  if (risk === 'marketRisks') {
    return 'Market Risks';
  } else if (risk === 'operationalRisks') {
    return 'Operational Risks';
  } else if (risk === 'financialRisks') {
    return 'Financial Risks';
  } else if (risk === 'legalAndRegulatoryRisks') {
    return 'Legal and Regulatory Risks';
  } else if (risk === 'technologicalRisks') {
    return 'Technological Risks';
  } else if (risk === 'humanResourceRisks') {
    return 'Human Resource Risks';
  } else if (risk === 'environmentalRisks') {
    return 'Environmental Risks';
  } else if (risk === 'other') {
    return 'Other';
  } else {
    return '';
  }
};
